import styled from 'styled-components';
import { absolutePosition } from '../../helper/css';

export const AbsolutePositioned = styled.div`
  ${(props) => absolutePosition(props.position)};
`;
